import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { UserService } from '@services/core/user.service';
import { StorageService } from '@services/core/storage.service';
import { AppVariablesService } from '@services/settings/app-variables.service';
import { AppSettings } from '@services/settings/app-settings.service';
import { HeaderComponent } from './components/core/header/header.component';
import { SidebarComponent } from './components/core/sidebar/sidebar.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from '@services/core/toast.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, HeaderComponent, SidebarComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  @Input() code?: any
  title = 'pres.Ui';
  isLogged
  authMicrosoft = inject(MicrosoftAuthService)
  activatedRoute = inject(ActivatedRoute)
  userService = inject(UserService)
  location = inject(Location)
  router = inject(Router)
  storageService = inject(StorageService)
  appVariablesService = inject(AppVariablesService)
  appSettings = inject(AppSettings)
  toastService = inject(ToastService)
  private destroyRef = inject(DestroyRef)
  swalBackground
  swalTextColor

  appVariables = this.appVariablesService.getAppVariables()



  ngOnInit() {
    this.isLogged = this.storageService.getJsonValue("logged");

    if (this.isLogged == null) {
      this.handleNotLoggedIn();
    } else {
    this.handleLoggedIn();
    }
  }

  private handleNotLoggedIn() {
    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (params["code"]) {
       this.getToken(params["code"]);
      } else {
        this.loginMicrosoft();
      }
    });
  }

  private handleLoggedIn() {

  const path = this.location.path().includes("?code") ? "" : this.location.path()
  this.router.navigateByUrl(path);
  this.getUserData();
  }

  // // set page minified
  onAppSidebarMinifiedToggled(val): void {
  	this.appSettings.appSidebarMinified = !this.appSettings.appSidebarMinified;
  	if (localStorage) {
  		localStorage['appSidebarMinified'] = this.appSettings.appSidebarMinified;
  	}
  }

  // onAppDarkModeChanged(val: boolean): void {

  //  	if (localStorage['appDarkMode'] === 'true') {  
  //     this.appSettings.appDarkMode=true;      
  // 		document.documentElement.setAttribute('data-bs-theme', 'dark');
  // 	} else {
  // 		document.documentElement.removeAttribute('data-bs-theme');
  //     this.appSettings.appDarkMode=false; 
  // 	}
  //   this.appSettings.appDarkMode
  //   this.appSettings.appGradientEnabled = (localStorage['appGradientEnabled'] === 'true') ? true : false;
  // 	this.appVariables = this.appVariablesService.getAppVariables();
  // 	this.appVariablesService.variablesReload.emit();
  // 	document.dispatchEvent(new CustomEvent('theme-change'));
  // }

  // // hide mobile sidebar
  onAppSidebarMobileToggled(val): void {
    this.appSettings.appSidebarMobileToggled = !this.appSettings.appSidebarMobileToggled;
  }

  loginMicrosoft() {
  	this.authMicrosoft.getTokenAPI().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
  		window.location.href = res.url;
  	});
  }

  getToken(code: string) {
  	try {
  		this.authMicrosoft.getAccessToken(code).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
  			this.authMicrosoft.token.set(res.access_token)
  			this.authMicrosoft.refreshToken.set(res.refresh_token);
        this.storageService.setJsonValue("logged", "true")
        this.storageService.setJsonValue("token", res.access_token)
        this.storageService.setJsonValue("refresh_token", res.refresh_token)
        if(this.router.url.includes("?code") ){
          const path = this.router.url.split("?")[0]
          this.router.navigateByUrl(path) 
        } 
  		this.getUserData();
  		})
  	} catch (error) {
  		console.error('Error al obtener el token:', error);
  	}
  }

  getUserData() {
  	this.authMicrosoft.decryptToken().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        try {
          this.userService.processUserData(res.user.user);
          this.userService.processUserPhoto(res.photo.body.data);
          this.userService.sharingEntities.set(res.user.entities);
          this.userService.sharingEntity.set(res.user.entity);
          this.userService.sharingIdentity.set(res.user.identity);
          this.userService.sharingMenu.set(res.user.menu);
          this.userService.sharingRole.set(res.user.role);
          this.isLogged = this.authMicrosoft.token;
        } catch (error) {
          console.error('Error en el procesamiento de datos:', error);
        }      

      // Swal.close()

      })
    }


}
